import React from 'react';
import MoneyComponent from 'react/elements/MoneyComponent';

/**
 * The status bar: what the cells you have selected add up to.
 *
 * This is the reason the grid has a multi-cell selection at all. Her sheet answered "what did the
 * groceries come to this month" by dragging down the column and reading the corner of the window,
 * and no amount of filtering on a transactions table replaces that -- the question is asked of an
 * arbitrary handful of rows, decided while looking at them, and is gone again a second later.
 *
 * Fixed to the bottom of the *window* rather than sitting under the tables, because the tables are
 * taller than the screen: a total at the end of the document is a total you have to scroll away
 * from the rows you are selecting to read.
 *
 * Hidden until two cells are selected, which is Excel's own rule. One cell is the resting state of
 * the grid -- arrowing around it would otherwise drag a bar of numbers along under every keystroke,
 * restating the amount already on screen under the cursor.
 *
 * Handed the figures rather than reading them out of the grid's context itself, which would have
 * meant importing from the module that renders it. That cycle happens to resolve, and there is no
 * reason to keep a component this simple leaning on it.
 *
 * @param summary {Object} from `summariseSelection()`
 */
export default function LedgerSelectionSummary({ summary }) {
	if(!summary || summary.count < 2) {
		return null;
	}

	return (
		<div className='ledger_selection_summary' role='status' aria-live='polite'>
			{summary.numeric > 0 &&
			<React.Fragment>
				<span className='statistic'>
					<span className='label'>Sum</span>
					<MoneyComponent amount={summary.sum} />
				</span>
				<span className='statistic'>
					<span className='label'>Average</span>
					<MoneyComponent amount={summary.average} />
				</span>
			</React.Fragment>
			}
			<span className='statistic'>
				<span className='label'>Count</span>
				{/* Both counts, because the difference between them is the answer to "why is that
				    sum smaller than I expected" -- a drag across whole rows picks up names and
				    dates, and only the amounts among them are in the total. */}
				<span className='count_value'>
					{summary.numeric > 0 && summary.numeric !== summary.count
						? `${summary.numeric} of ${summary.count}`
						: summary.count}
				</span>
			</span>
		</div>
	);
}
